export default {
    namespaced: true,
    state: {
		endpoint: 'realty/category',
		item: {},
        items: [],
    },
}